var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponseRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0003 64.0001C14.3871 64.0001 0.000732422 49.6137 0.000732422 32.0005C0.000732422 14.3873 14.387 0.000934902 32.0003 0.000934902C49.6134 -0.133523 63.9998 14.2529 63.9998 31.866C63.9998 49.4792 49.6134 64.0001 32.0003 64.0001ZM32.0003 3.9001C16.5383 3.9001 4.03423 16.4041 4.03423 31.8662C4.03423 47.3282 16.5383 59.8321 32.0003 59.8321C47.4622 59.8321 59.9664 47.3281 59.9664 31.866C59.9664 16.404 47.4622 3.9001 32.0003 3.9001Z",
    fill: "#FF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3109 33.8831H32.0001C30.9245 33.8831 29.9834 32.9419 29.9834 31.8664C29.9834 30.7908 30.9246 29.8496 32.0001 29.8496H45.3109C46.3866 29.8496 47.3276 30.7908 47.3276 31.8664C47.3276 33.0764 46.3864 33.8831 45.3109 33.8831Z",
    fill: "#FF4040"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 33.8831H18.6894C17.6137 33.8831 16.6726 32.9419 16.6726 31.8664C16.6726 30.7908 17.6138 29.8496 18.6894 29.8496H32.0001C33.0758 29.8496 34.0169 30.7908 34.0169 31.8664C34.0169 33.0764 33.0756 33.8831 32.0001 33.8831Z",
    fill: "#FF4040"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponseRejectIcon);
export default __webpack_public_path__ + "static/media/response-reject-icon.1a176d769aed277592a53cc8fe07a508.svg";
export { ForwardRef as ReactComponent };